// Mesquite Mafia: Progression Missions
import { state, log, updateCurrencies, updateHUDDirective, addXP } from '../core/state.js';
import { playSFX } from '../core/audio.js';
import { syncStateToD1, callServerAction } from '../services/api.js';

export function updateMissionProgress(actionOrCat, amountOrKey, valOrIsSet, isSet = false) {
      if (!state.missions) return;

      let matched = false;
      for (let chKey in state.missions) {
        const ch = state.missions[chKey];
        if (!ch || !ch.tasks) continue;
        for (let tKey in ch.tasks) {
          const t = ch.tasks[tKey];
          if (t.targetAction === actionOrCat || t.id === actionOrCat || tKey === amountOrKey) {
            matched = true;
            if (t.done) continue;
            if (valOrIsSet === true || isSet === true) {
              t.progress = typeof amountOrKey === 'number' ? amountOrKey : (typeof valOrIsSet === 'number' ? valOrIsSet : t.req);
            } else {
              t.progress = (t.progress || 0) + (typeof amountOrKey === 'number' ? amountOrKey : 1);
            }
            if (t.progress >= t.req) {
              t.progress = t.req;
              SFX.cash();
              playActionSequence({
                title: "DIRECTIVE ACCOMPLISHED",
                icon: "⭐",
                detail: t.title,
                rewardText: "CLAIMABLE ON HUD & MISSIONS TAB",
                shots: 1
              });
            }
          }
        }
      }

      // Legacy fallback
      if (!matched && state.missions[actionOrCat] && state.missions[actionOrCat][amountOrKey]) {
        let m = state.missions[actionOrCat][amountOrKey];
        if (!m.done) {
          if (valOrIsSet) m.progress = valOrIsSet;
          else m.progress = (m.progress || 0) + 1;
          if (m.progress >= m.req) m.progress = m.req;
        }
      }

      updateHUDDirective();
      renderMissions();
      syncStateToD1();
    }

export function claimMission(chapterKey, taskKey) {
      if (!state.missions || !state.missions[chapterKey] || !state.missions[chapterKey].tasks || !state.missions[chapterKey].tasks[taskKey]) {
        if (state.missions && state.missions[chapterKey] && state.missions[chapterKey][taskKey]) {
          let m = state.missions[chapterKey][taskKey];
          if (m.progress >= m.req && !m.done) {
            m.done = true;
            state.cred += 500;
            SFX.cash();
            updateCurrencies();
            renderMissions();
            syncStateToD1();
          }
        }
        return;
      }

      let m = state.missions[chapterKey].tasks[taskKey];
      if (m.progress >= m.req && !m.done) {
        m.done = true;
        if (m.reward.cash) state.cash += m.reward.cash;
        if (m.reward.cleanCapital) state.cleanCapital = (state.cleanCapital || 0) + m.reward.cleanCapital;
        if (m.reward.scrap) state.scrap += m.reward.scrap;
        if (m.reward.cred) state.cred += m.reward.cred;
        if (m.reward.product) state.product += m.reward.product;
        if (m.reward.xp) addXP(m.reward.xp);
        if (m.reward.unlockSector && state.territories[m.reward.unlockSector]) {
          state.territories[m.reward.unlockSector].unlocked = true;
        }

        SFX.cash();
        updateCurrencies();
        updateHUDDirective();
        renderMissions();
        updateSectorLockVisuals();
        syncStateToD1();

        let rText = [];
        if (m.reward.cash) rText.push(`+$${m.reward.cash.toLocaleString()} Cash`);
        if (m.reward.cleanCapital) rText.push(`+$${m.reward.cleanCapital.toLocaleString()} Clean`);
        if (m.reward.scrap) rText.push(`+⚙️ ${m.reward.scrap} Scrap`);
        if (m.reward.cred) rText.push(`+💎 ${m.reward.cred} Cred`);
        if (m.reward.xp) rText.push(`+${m.reward.xp} XP`);
        if (m.reward.unlockSector) rText.push(`Sector ${m.reward.unlockSector.toUpperCase()} Unlocked`);

        playActionSequence({
          title: "BOUNTY COLLECTED",
          icon: "🎖️",
          detail: `Directive Done: ${m.title}`,
          rewardText: rText.join(' • '),
          shots: 1
        });
      }
    }

export function renderMissions() {
      const container = document.getElementById('mission-container');
      if (!container) return;
      let html = "";

      for (let chKey in state.missions) {
        const ch = state.missions[chKey];
        if (!ch || !ch.tasks) continue;

        const allDone = Object.values(ch.tasks).every(t => t.done);
        html += `
          <div style="margin-bottom: 24px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 6px;">
              <div style="font-size: 1.15rem; font-weight: 800; text-transform: uppercase; color: var(--accent-gold); letter-spacing: 0.5px;">
                ${ch.name}
              </div>
              <div style="font-size: 0.75rem; font-weight: 800; color: ${allDone ? '#4ade80' : '#94a3b8'};">
                ${allDone ? '✅ CHAPTER COMPLETE' : '⚡ IN PROGRESS'}
              </div>
            </div>
            <div class="mission-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 14px;">
        `;

        for (let tKey in ch.tasks) {
          const m = ch.tasks[tKey];
          const pct = Math.min(100, Math.floor(((m.progress || 0) / m.req) * 100));

          let rewBadges = [];
          if (m.reward.cash) rewBadges.push(`+$${m.reward.cash.toLocaleString()}`);
          if (m.reward.cleanCapital) rewBadges.push(`+$${m.reward.cleanCapital.toLocaleString()} Clean`);
          if (m.reward.scrap) rewBadges.push(`+${m.reward.scrap} ⚙️`);
          if (m.reward.cred) rewBadges.push(`+${m.reward.cred} 💎`);
          if (m.reward.product) rewBadges.push(`+${m.reward.product} 📦`);
          if (m.reward.xp) rewBadges.push(`+${m.reward.xp} XP`);
          if (m.reward.unlockSector) rewBadges.push(`🔓 Sector ${m.reward.unlockSector.toUpperCase()}`);

          html += `
            <div class="item-card specular-hairline volumetric-hover" style="background: var(--hf-surface); border: 1px solid ${m.done ? 'rgba(34, 197, 94, 0.3)' : 'var(--hf-border-subtle)'}; position: relative; padding: 14px; border-radius: 6px;">
              ${m.done ? '<div style="position:absolute; top: 10px; right: 10px; font-size: 1.2rem;">✅</div>' : ''}
              <div style="font-size: 0.95rem; font-weight: 800; color: #fff; margin-bottom: 4px;">${m.title}</div>
              <div style="font-size: 0.76rem; color: #94a3b8; margin-bottom: 10px; min-height: 32px;">${m.desc}</div>
              
              <div style="display: flex; gap: 4px; flex-wrap: wrap; margin-bottom: 10px;">
                ${rewBadges.map(r => `<span style="font-size: 0.68rem; font-weight: 800; background: rgba(15, 23, 42, 0.8); border: 1px solid rgba(255,255,255,0.1); color: #4ade80; padding: 2px 6px; border-radius: 3px;">${r}</span>`).join('')}
              </div>

              <div style="background: #000; height: 8px; border-radius: 4px; overflow: hidden; margin-bottom: 10px; border: 1px solid rgba(255,255,255,0.06);">
                <div style="background: ${m.done ? '#22c55e' : 'linear-gradient(90deg, #0284c7, #38bdf8)'}; width: ${pct}%; height: 100%;"></div>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div style="font-size: 0.76rem; font-weight: 800; color: #cbd5e1;">${m.progress || 0} / ${m.req}</div>
                <button class="action-btn-small" style="background: ${m.done ? '#334155' : (m.progress >= m.req ? 'var(--accent-green)' : '#0284c7')}; color: ${m.done ? '#94a3b8' : '#000'}; font-weight: 800; font-size: 0.74rem;" 
                        ${m.done ? 'disabled' : (m.progress >= m.req ? `onclick="claimMission('${chKey}', '${tKey}')"` : `onclick="switchTab('${m.targetTab || 'compound'}')"`)}>
                  ${m.done ? 'Claimed' : (m.progress >= m.req ? 'Claim Reward' : 'Go To Mission')}
                </button>
              </div>
            </div>
          `;
        }
        html += `</div></div>`;
      }
      container.innerHTML = html;
    }

export function hydrateMissionsFromSaved(saved) {
      if (!saved) return;
      for (let cKey in state.missions) {
        if (saved[cKey] && saved[cKey].tasks) {
          for (let tKey in state.missions[cKey].tasks) {
            if (saved[cKey].tasks[tKey]) {
              state.missions[cKey].tasks[tKey].progress = saved[cKey].tasks[tKey].progress;
              state.missions[cKey].tasks[tKey].done = saved[cKey].tasks[tKey].done;
            }
          }
        }
      }
    }

